import * as React from 'react';
import { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';

import { httpRequest } from '../../api/helper';
import { useNotification } from '../../context/NotificationContext';
import { API_ERROR_MESSAGE } from '../../common/AppConstants';
import { Helmet } from 'react-helmet';
import logger from '../../logger';

export default function ForgotPassword() {
  const { addNotification } = useNotification();
  const [isResetLoading, setIsResetLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [editErrors, setEditErrors] = useState({});

  const resetAllErrors = () => {
    setEditErrors({});
  };

  useEffect(() => {
    resetAllErrors();
  }, []);

  const handleChange = (fieldAttr, value) => {
    // Clear error when user edits the field
    setEditErrors((prevErrors) => ({
      ...prevErrors,
      [fieldAttr]: undefined,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsResetLoading(true); // Disable button
    resetAllErrors();
    const form_data = new FormData(event.currentTarget);

    // Send password reset link
    const data = {
      email: form_data.get('email'),
    };

    await httpRequest({
      method: 'POST',
      url: 'user/forgot-password/',
      data: data,
      onSuccess: (data) => {
        setSubmitted(true);
        addNotification('Password reset email is sent on the email.', 'success');
      },
      onFailure: (data) => {
        setEditErrors(data);
      },
      addNotification,
    });
    
    setIsResetLoading(false);
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: 2,
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography variant="h1">Forgot Password</Typography>
          {submitted ? (
            <Typography sx={{ mt: 2 }}>
              Please check your email for the instructions to reset the
              password.
            </Typography>
          ) : (
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={(e) => handleChange('email', e.target.value)}
                disabled={isResetLoading}
                error={Boolean(editErrors.email)}
                helperText={editErrors.email?.[0] || ''}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={isResetLoading}
              >
                {isResetLoading ? 'Sending Email' : 'Send Reset Email'}
              </Button>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Link href="/sign-in" variant="body2">
                    Back to Sign In
                  </Link>
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>
      </Container>
    </>
  );
}
